export enum RepresentativesType {
Technitian,
Doctor,
}
